import MarketingGroupFormPage from "./marketingGroupFormPage";

const CreateMarketingGroup = () => <MarketingGroupFormPage mode="create" />;

export default CreateMarketingGroup;
